import { defineStore } from 'pinia';
import { setStore } from '@/lib/localStore';
import { applyTheme } from '@/lib/theme';

export const rootStore = defineStore('rootStore', {
  state: () => {
    return {
      loginFlag: false,
      isManager: false,
      isBackendManagerOrDeveloper: false,
      isBackendPermissionAllocator: false,
      userName: '',
      userInfo: null,
      userList: [],
      unreadCount: 0,
      unreadList: [],
      departmentUsers: [],
      systemSetting: {
        hideMenu: true, // 隐藏菜单
        darkMode: false,
        homeViewMode: 'list', // list | card
        homeOpenTarget: 'newTab', // newTab | sameTab
      },
    };
  },
  actions: {
    setLoginFlag(v) {
      this.loginFlag = v;
    },
    setUserInfo(data) {
      if (data) {
        this.isManager = data.is_manager;
        this.isBackendManagerOrDeveloper = data.is_backend_manage_or_developer;
        this.isBackendPermissionAllocator = data.is_backend_permission_allocator;
        this.userName = data.realname;
        this.userInfo = data;
      }
    },
    setUserList(arr) {
      this.userList = arr;
    },
    setUnreadList(data) {
      this.unreadList = data;
      this.unreadCount = data.reduce((sum, item) => sum + item.count, 0);
    },
    setDepartmentUsers(data) {
      this.departmentUsers = data;
    },
    setSystemSetting(key, value = null) {
      if (!key) return;

      switch (key) {
        case 'hideMenu':
        case 'darkMode':
          this.systemSetting[key] = value !== null ? value : !this.systemSetting[key];
          if (key === 'darkMode') {
            applyTheme(this.systemSetting.darkMode);
          }
          break;
        default:
          this.systemSetting[key] = value;
          break;
      }
      setStore({ name: 'systemSetting', content: this.systemSetting });
    },
  },
});
